import React, {useEffect} from 'react';
import {Popup, useMap} from "react-leaflet";
import { useDispatch, useSelector} from "react-redux";
import {selectArrival, selectDeparture, selectStop} from '../../../../../data/booking/actions/map'
import {LodgingMarker} from "./Marker";
import {AddButton} from "../../../../shared/components/Buttons";

function StopsLayer() {
    const stops = useSelector(state => state.booking.map.stops)
    const moseOverStopId = useSelector(state => state.booking.map.moseOverStopId)
    const {selectedStop , startStep, endStep} = useSelector(state => state.booking.map.trip)
    const dispatch = useDispatch()
    return stops.map((stop,i) => <LodgingMarker
        selected={stop.id == moseOverStopId || (selectedStop && stop.id == selectedStop.id) || (startStep.stop && stop.id == startStep.stop.id) || (endStep.stop && stop.id == endStep.stop.id)}
        key={stop.id}
        position={[stop.stop.latitude, stop.stop.longitude]} >
        <Popup>
            <div className="text-center p-2">
                <p className="mb-3 text-base font-medium text-gray-700">{stop.title}</p>
                {stop.address}
                <button onClick={() => {
                    rduxFm.setFormValue(rduxFm.currentField, stop)
                    rduxFm.setFormValue(`${rduxFm.currentField}Step`, stop.step)

                    if(rduxFm.currentField == 'from'){
                        dispatch(selectDeparture(stop.step, stop.stop))
                    } else if(rduxFm.currentField == 'to'){
                        dispatch(selectArrival(stop.step, stop.stop))
                    }
                    dispatch(selectStop(stop.step, stop.stop))
                }
                } className="
                inline-flex items-center justify-self-end rounded-md border border-transparent
                py-2 pl-6 pr-6 text-base font-medium shadow-sm  first-letter:uppercase focus:outline-none
                bg-orange-600 text-white hover:bg-orange-700 focus:ring-2 focus:ring-orange-500 focus:ring-offset-2">Choisir cet hébergement</button>
            </div>
        </Popup>
    </LodgingMarker>)
}
export default StopsLayer;